import React, { Fragment } from "react";
import Icon, { IconName } from "./icon";
const SiteOverlay = _ref => {
    let { children, open = false, maxWidthContent = 600, onClose } = _ref;
    if (open) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "fixed inset-0 z-50",
            style: {
                backgroundColor: "rgba(0,0,0,0.6)"
            }
        }, /*#__PURE__*/ React.createElement("button", {
            className: "absolute top-0 right-0 p-4 focus:outline-none",
            onClick: onClose
        }, /*#__PURE__*/ React.createElement(Icon, {
            iconName: IconName.CLOSE,
            className: "w-12"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "w-full h-full flex flex-col justify-center mx-auto",
            style: {
                maxWidth: maxWidthContent + "px"
            }
        }, /*#__PURE__*/ React.createElement("div", null, children)));
    }
    return /*#__PURE__*/ React.createElement(Fragment, null);
};
export default SiteOverlay;
